import { toRelativeUrl } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import { useEffect, useRef } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { rootPaths } from "./routePaths";
import { useGetUserPermission } from "../api/permission";
import Loading from "../components/molecules/Loading";
import { MODULE } from "../constants/constants";
import { UserActionsResponse } from "../models/Authorisation";
import { usePermissionStore } from "../stores/permissionStore";
import { useUserStore } from "../stores/userStore";

export const RequiredAuth = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [user, setUser, setUserActions, setUserRole, setCountry, setLeadsUserAction,] = useUserStore(
    state => [
      state.user,
      state.setUser,
      state.setUserActions,
      state.setUserRole,
      state.setCountry,
      // state.setPpsUserAction,
      state.setLeadsUserAction
    ],
  );

  const { permissionToken, setPermission } = usePermissionStore();

  const {
    data: userPermission,
    isLoading,
    isError,
    error,
  } = useGetUserPermission({ enabled: !!authState?.isAuthenticated } as any);

  useEffect(() => {
    if (userPermission) {
      const permissionInventory = userPermission.data?.permissions?.find(
        (item: UserActionsResponse) => item.module === MODULE.INVENTORY,
      );
      const permissionLeads = userPermission.data?.permissions?.find(
        (item: UserActionsResponse) => item.module === MODULE.LEADS,
      );
      // const permissionPps = userPermission.data?.permissions?.find(
      //   (item: UserActionsResponse) => item.module === MODULE.PPS,
      // );
      setUserActions(permissionInventory?.allowedActions);
      // setPpsUserAction(permissionPps?.allowedActions);
      setLeadsUserAction(permissionLeads?.allowedActions.actions);
      setUserRole(permissionInventory?.userRole);
      setPermission(userPermission.data);
      setCountry(permissionInventory?.countries);
    }
  }, [userPermission]);

  const redirectStartedRef = useRef(false);

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState.isAuthenticated && !redirectStartedRef.current) {
      redirectStartedRef.current = true;
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin,
      );
      oktaAuth.setOriginalUri(originalUri);
      (async () => {
        try {
          await oktaAuth.signInWithRedirect();
        } catch (e) {
          console.error(e);
        }
      })();
    }
    if (authState && authState.isAuthenticated) {
      oktaAuth
        .getUser()
        .then(info => {
          if (!user?.name) {
            setUser({
              name: info.name,
              email: info.email,
              id: info.sub,
            });
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  }, [authState?.isAuthenticated]);

  if (
    !authState ||
    !authState?.isAuthenticated ||
    isLoading ||
    !permissionToken
  ) {
    return <Loading />;
  }

  if (isError && error) {
    return <Navigate to={rootPaths.unauthorised} />;
  }

  return <Outlet />;
};
